<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class CustomAdditionalOptions extends Vue {
        @Prop() productName

        render() {
            return null
        }
    }

    export default CustomAdditionalOptions
</script>
